import {
  PiCheckCircleBold,
  PiClockAfternoonBold,
  PiHourglassSimpleBold,
} from "react-icons/pi";
import { convertDate } from "../../../utils/convertDate";
import { Link } from "react-router-dom";

function TicketCard({ data }) {
  return (
    <div className="w-full flex flex-col gap-2 py-8 bg-white dark:bg-gray-800 rounded-md px-4 border-b-2 border-gray-300">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 flex items-center justify-center text-gray-500 dark:text-white">
          {data?.status === "open" ? (
            <PiHourglassSimpleBold size={26} className="text-orange-400" />
          ) : (
            <PiCheckCircleBold size={26} className="text-green-500" />
          )}
        </div>
        <div className="w-[calc(100%_-_2.5rem)] flex flex-col gap-4">
          <p className="w-full  text-base font-bold text-gray-500 dark:text-white tracking-tight truncate">
            {data?.title}
          </p>
          <div className="flex justify-between text-sm text-gray-500 dark:text-gray-100 flex-wrap">
            <div className="flex gap-2">
              <div className="flex items-center gap-2 text-xs">
                <PiClockAfternoonBold size={18} />
                <span>{convertDate(data?.createdAt)}</span>
              </div>{" "}
              {data?.answered ? (
                <span className="text-green-500">پاسخ داده شده</span>
              ) : (
                <span className="text-blue-500">پاسخ داده نشده</span>
              )}
            </div>
            <Link
              to={`/ticket/${data._id}`}
              className="text-blue-500 dark:text-blue-200 text-sm"
            >
              مشاهده
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TicketCard;
